// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ProjectPage_Wrapper__FeDUu","Projects":"ProjectPage_Projects__rDeOc"};